import { getItemFromCollection } from "directus/src/operations";

export async function fetchTechStackData({ techStackId }) {
  try {
    const response = await getItemFromCollection("tech_stack", techStackId);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
